<style lang="less"  scoped>
    @import "../../style/common.less";
	@import "../../style/button.css";
</style>

<template>
    <div class="iot-vue-container">
        <!-- 标题组件 -->
        <div class="vue-header">
            <div class="vue-header-title-div">
                <span class="vue-header-title" @click="init()">{{pageTitle}}</span>
            </div>
            <div class="vue-header-breadcrumb">
                <Breadcrumb>
<!--                    <BreadcrumbItem :to="{name:sysCfg.mainPage}">首页</BreadcrumbItem>-->
<!--                    <BreadcrumbItem>{{sysCfg.modules.sysManage}}</BreadcrumbItem>-->
<!--                    <BreadcrumbItem>{{sysCfg.modules.sysManage}}</BreadcrumbItem>-->
<!--                    <BreadcrumbItem :to="{name:sysCfg.user.name_en}">{{sysCfg.user.name}}</BreadcrumbItem>-->
                </Breadcrumb>
            </div>
        </div>
        <div class="vue-main">
            <div class="iot-form">
                <Form ref="formForm" :model="formInfo" :rules="ruleValidate">
                    <div class="flex-div">
                        <div class="flex-div-child">
                            <FormItem label="用户账号" prop="userAcc">
                                <Input v-model="formInfo.userAcc"  :disabled="editFlag"></Input>
                            </FormItem>
                            <FormItem label="用户名称" prop="userName">
                                <Input v-model="formInfo.userName"></Input>
                            </FormItem>
                            <FormItem label="密码" v-if="editFlag === false" prop="userPassword">
                                <Input v-model="formInfo.userPassword" type="password"></Input>
                            </FormItem>
<!--							<FormItem label="工号" prop="zyCd">-->
<!--								<Input v-model="formInfo.zyCd" ></Input>-->
<!--							</FormItem>-->
                            <FormItem label="角色" prop="roleId">
                                <Select v-model="formInfo.roleId">
                                    <Option  v-for="option in roleList"  :key="option.roleId" v-bind:value="option.roleId">
                                        {{option.roleName}}
                                    </Option>
                                </Select>

                                <!--<el-select v-model="formInfo.roleId" class="scada-el-select">
                                    <el-option  v-for="option in roleList" :key="option.roleId" :label="option.roleName" :value="option.roleId">
                                    </el-option>
                                </el-select>-->
                            </FormItem>
                            <FormItem label="工厂" prop="plantNo">
                                <Select v-model="formInfo.plantNo" @on-change="updateDept" >
                                    <Option  v-for="option in plantList" :key="option.plantId"  v-bind:value="option.plantId">
                                        {{option.plantName}}
                                    </Option>
                                </Select>
                                 <!-- @on-change="updateDept" -->

                               <!--  <el-select v-model="formInfo.plantNo" class="scada-el-select">
                                    <el-option  v-for="option in plantList" :key="option.plantNo" :label="option.plantName" :value="option.plantNo">
                                    </el-option>
                                </el-select>-->
                            </FormItem>
<!--                            <FormItem label="部门" prop="deptId">-->
<!--                                <Select v-model="formInfo.deptId">-->
<!--                                    <Option  v-for="option in deptList" :key="option.deptId"  v-bind:value="option.deptId">-->
<!--                                        {{option.deptName}}-->
<!--                                    </Option>-->
<!--                                </Select>-->

<!--                                  &lt;!&ndash;<el-select v-model="formInfo.deptNos" class="scada-el-select">-->
<!--                                    <el-option  v-for="option in deptList" :key="option.deptNo" :label="option.deptName" :value="option.deptNo">-->
<!--                                    </el-option>-->
<!--                                </el-select> &ndash;&gt;-->
<!--                            </FormItem>-->
                        </div>
                        <div class="flex-div-child"></div>
                    </div>
                    <FormItem class="iot-form-actions-div">
						<button @click="$store.commit('DelTab')">close tab</button>
						<Button type="primary" @click="submitForm('formForm')" class="button button-glow button-rounded button-border button-highlight" v-loading.fullscreen.lock="fullscreenLoading"><i class="fa fa-save"></i>&nbsp;&nbsp;提交</Button>
						<Button type="ghost" @click="resetForm('formForm')" class="button button-glow button-rounded button-border button-highlight"><i class="fa fa-close"></i>&nbsp;&nbsp;重置</Button>
                    </FormItem>
                </Form>
            </div>
        </div>
    </div>
</template>


<script>
    import config from '@/config/config.js';
	import msgCfg from '@/config/msg.js';
	import { mapActions } from "vuex";
	// import { mapState,mapMutations } from 'vuex'
    export default {
		props:['name'],
        data() {
            return {
                pageTitle: '用户新增',
                fullscreenLoading: false,
                sysCfg: config,
                editId: '',
                editFlag: false,
                formInfo: {
                    roleId:'',
                    plantNo:'',
                    deptNos:'',
                },
                roleList: [],
                plantList: [],
                deptList: [],
                listRouter:'userlist',
                ruleValidate: {
                    userAcc: [{
                        required: true,
                        message: '请输入用户账号',
                        trigger: 'blur'
                    }],
                    userName: [{
                        required: true,
                        message: '请输入用户账号',
                        trigger: 'blur'
                    }],
                    userPassword: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }],
                    roleId: [{
                        required: true,
                        message: '请选择角色',
                        trigger: 'change'
                    }],
                    plantNo: [{
                        required: true,
                        message: '请选择工厂',
                        trigger: 'change'
                    }],
                    // zyCd: [{
                    //     required: true,
                    //     message: '请输入工号',
                    //     trigger: 'change'
                    // }],
                }
            };
        },
        methods: {
			...mapActions("tab", ["reflush"]),
            init() {
                var _this = this;
                this.editId = this.$route.params.id;
                // alert("===2=="+this.$route.params.id);
                if (this.editId) {
                    //获取对象详细信息
                    this.getDetailInfo(this.editId);
                    this.editFlag = true;
                    this.pageTitle = "用户编辑";
                }
                // 角色
                this.roleList = this.$job.getRoleList(this);
                // 工厂
                this.plantList = this.$job.getPlantList(this);
                // 部门
                // this.deptList = this.$job.getDeptList(this);
            },
            // 获取详细信息
            getDetailInfo(id) {
                var _this = this;
                var url = _this.$api.user.list + '/' + id;
                _this.$httpUtil.ajaxGet(this, url, {}, function(response) {
                    var tempData = response.data.data;
                    _this.$job.getDeptListByPlantId(_this, tempData.plantNo, function(res) {
                        _this.deptList = res;
                        _this.formInfo = tempData;
                    });
                });
            },
            // 表单提交
            submitForm(formName) {

                // var _this = this;
                // _this.$store.commit('tab/DelTab');
                // if(_this.formInfo.zyCd!=undefined && _this.formInfo.zyCd.length<5){
				// 	_this.$util.error(msgCfg.WEB6055W);//工号必须满五位
				// 	return;
				// }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var url = this.$api.user.list;
                        this.$service.submitForm(this, url,this.listRouter);
                    }
                });
            },
            // 更新部门
            updateDept(val) {
                var _this = this;
                this.formInfo.deptNos = '';
                this.$job.getDeptListByPlantId(this, val,function(res){
                    _this.deptList = res;
                });
            },
            // 返回列表
            backToList() {
                this.fullscreenLoading = false;
                var _this = this;
                this.$router.push({
                    name:_this.listRouter
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.init();
            }
        },
        mounted() {
			// this.id = this.$route.params.id;
            this.init();
        },
        updated(){
            // this.$refs['formForm'].validate((valid) => {});
        },
        watch: {
            // 'formInfo'(){
            //     this.$refs['formForm'].validate((valid) => {});
            // }
        },
    };
</script>



// WEBPACK FOOTER //
// src/views/user/Detail.vue